export { default } from './TermsAndConditions'
export * from './TermsAndConditions'
